import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-placement-time-sheet',
  templateUrl: './placement-time-sheet.component.html',
  styleUrls: ['./placement-time-sheet.component.css']
})
export class PlacementTimeSheetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
